import React from "react";

const ButtonCard = (props) => (
    <div className={props.className} onClick={props.onClick} style={{cursor:"pointer"}}>
      <div className="inner" style={{textAlign: "center"}}>
            <h5>{props.title}</h5>      
      </div>
    </div>
);

export default ButtonCard;